import { Injectable, inject } from '@angular/core';

import {
  Observable,
  Subject,
  catchError,
  finalize,
  of,
  retryWhen,
  tap,
} from 'rxjs';

import { retryStrategy } from '@personal-area/global/http/services';

import { CountryChangeStatus, CountryChangeStatusEnum } from '../models/status';
import { CountryChangeApiService } from './country-change.api.service';

@Injectable({ providedIn: 'root' })
export class CountryChangerService {
  public userCountryStatusChanged = new Subject<void>();

  private _status: CountryChangeStatus;
  private _isStatusPending: boolean;
  private _countryChangeApiService = inject(CountryChangeApiService);

  public refreshStatus() {
    this._status = null;
  }

  public setStatus(status: CountryChangeStatus, updatedAt: string) {
    this._status = {
      ...this._status,
      ...status,
      updatedAt,
    };
  }

  public getStatus(): Observable<CountryChangeStatus> {
    if (this._status || this._isStatusPending) {
      return of(this._status);
    }

    if (!this._isStatusPending) {
      this._isStatusPending = true;

      return this._countryChangeApiService
        .getCountryRequestStatus()
        .pipe(
          retryWhen(retryStrategy()),
          finalize(() => (this._isStatusPending = false)),
          catchError(() => {
            this._status = { status: CountryChangeStatusEnum.initial };
            return of(this._status);
          }),
          tap((data) => (this._status = data)),
        );
    }
  }
}
